//deps
import React, { memo, ReactElement, useMemo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import styles from "../LinkAccountPhoneNumber.scss";

//helpers
import { getAccessibleMobileText } from "@payment-ui/helpers/Wallet";

//widgets
import { PaymentMethodIcon } from "@payment-ui/widgets/payment-method-icon";
import { format } from "@swiggy-private/core-ui";

// constants
import { TEXTS as COMMON_TEXTS } from "@payment-ui/constants/index";
import { TEXTS as WALLET_TEXTS } from "@payment-ui/constants/Wallet";

//test-ids
import { LINK_ACCOUNT_PHONE_NUMBER_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface HeaderProps {
    editableState: { isEditable: boolean; registeredMobileNumber: string };
    iconUrl: string;
    displayName: string;
}

function Header(props: HeaderProps): ReactElement {
    const { displayName, editableState, iconUrl } = props;
    const { isEditable, registeredMobileNumber } = editableState;

    const title = useMemo(() => {
        return isEditable
            ? format(COMMON_TEXTS.LINK_MOBILE_NUMBER_TITLE, displayName)
            : format(WALLET_TEXTS.WALLET_PROCEED_TO_LINK, displayName);
    }, [displayName, isEditable]);

    const accessibleMobileText = useMemo(() => getAccessibleMobileText(registeredMobileNumber), [
        registeredMobileNumber,
    ]);

    return (
        <div className={styles.linkPhoneNumberHeader}>
            <div>
                <Text
                    variant="V2.subheading1.neutral.bold"
                    color="text_Highest_Emphasis"
                    className={styles.linkPhoneNumberHeaderTitle}
                    data-testid={LINK_ACCOUNT_PHONE_NUMBER_TEST_IDS.TITLE}
                >
                    {title}
                </Text>
                {!isEditable && (
                    <Text
                        variant="V2.body2.neutral.medium"
                        color="text_Highest_Emphasis"
                        aria-label={accessibleMobileText}
                        className={styles.linkPhoneNumberHeaderRegisteredNumber}
                        data-testid={LINK_ACCOUNT_PHONE_NUMBER_TEST_IDS.REGISTERED_NUMBER_FIELD}
                    >
                        {registeredMobileNumber}
                    </Text>
                )}
            </div>
            <PaymentMethodIcon
                parentClassName={styles.linkPhoneNumberHeaderIcon}
                src={iconUrl}
                data-testid={LINK_ACCOUNT_PHONE_NUMBER_TEST_IDS.METHOD_ICON}
            />
        </div>
    );
}

export default memo(Header);
